import React from 'react'
import styled, { keyframes } from 'styled-components'

// Sentinel-scoring twin of TimeSeriesLoadingDots: the same staggered
// "rise from the ground" motion, but the four dots are the arithmetic
// operators — a band is being computed, not data fetched. Sits in the
// action bar's loading slot next to a "Calculating" label.

const VB_W = 60
const VB_H = 22
const GROUND_Y = 18
const SYMBOL_XS = [8, 21, 34, 47]
const SYMBOLS = ['+', '−', '×', '÷']
// How high each symbol rises. Varied so the row reads as activity, not a
// progress bar (same values as the dots variant).
const RISES = [-11, -7, -13, -9]
const LOOP_SECONDS = 1.6
const STAGGER = 0.14

const rise = keyframes`
  0%   { transform: translateY(0); }
  40%  { transform: translateY(var(--rise)); }
  80%  { transform: translateY(0); }
  100% { transform: translateY(0); }
`

const Svg = styled.svg`
  width: 1.75rem;
  height: 0.65rem;
  overflow: visible;
`

const Symbol = styled.text<{ $delay: number }>`
  fill: rgba(255, 255, 255, 0.92);
  font-size: 11px;
  font-weight: 600;
  transform-box: fill-box;
  transform-origin: center;
  animation: ${rise} ${LOOP_SECONDS}s cubic-bezier(0.22, 1, 0.36, 1) infinite;
  animation-delay: ${({ $delay }) => $delay}s;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`

export const SentinelCalculatingDots: React.FC = () => (
  <Svg viewBox={`0 0 ${VB_W} ${VB_H}`} aria-hidden='true'>
    {SYMBOL_XS.map((x, i) => (
      <Symbol
        key={x}
        x={x}
        y={GROUND_Y}
        textAnchor='middle'
        style={{ '--rise': `${RISES[i]}px` } as React.CSSProperties}
        $delay={i * STAGGER}>
        {SYMBOLS[i]}
      </Symbol>
    ))}
  </Svg>
)
